var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._g(_vm._b({staticClass:"sa-sidebar-sidebar"},'div',_vm.data.attrs,false),_vm.listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }